import React from 'react'

import * as S from './styles'

import ButtonDefault from '../../../../ui/Buttons/ButtonDefault'
import ButtonPrimary from '../../../../ui/Buttons/ButtonPrimary'
import Input from '../../../../ui/Form/Input'
import ModalDefault from '../../../../ui/Modals/ModalDefault'

function ModalRecover (props) {
  const [email, setEmail] = React.useState('')
  const [disable, setDisable] = React.useState(true)

  React.useEffect(() => {
    if (!email) {
      setDisable(true)
    } else {
      setDisable(false)
    }
  }, [email])

  async function handleSubmit (e) {
    setEmail('')
    props.handleSubmitRecover(e, email)
  }

  return (
    <ModalDefault
      active={props.active}
      title='Recuperação de senha'
      onClick={() => props.setRecoverModalActive(false)}
    >

      <p>
        Por favor, confirme-nos o email associado a sua conta, para envio do link de recuperação de senha
      </p>

      <S.Space />

      <Input
        label='Email'
        required
        type='email'
        onChange={e => setEmail(e.target.value)}
        value={email}
      />

      <S.FlexContainer>

        <S.ButtonContainer>
          <ButtonDefault
            upperCase
            size='md'
            text='Cancelar'
            onClick={() => props.setRecoverModalActive(false)}
          />
        </S.ButtonContainer>

        <S.ButtonContainer>
          <ButtonPrimary upperCase size='md' text='Confirmar' disabled={disable} onClick={handleSubmit} />
        </S.ButtonContainer>

      </S.FlexContainer>

    </ModalDefault>
  )
}

export default ModalRecover
